import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { TrendingUp, TrendingDown } from 'lucide-react';

const StatsCard = ({ 
  title, 
  value, 
  icon, 
  trend, 
  color = 'primary',
  subtitle 
}) => {
  // Use theme colors instead of hardcoded CSS variables
  const getColorStyles = (theme) => {
    const colorMap = {
      primary: {
        bg: theme.palette.primary.main + '1A', // 10% opacity
        color: theme.palette.primary.main,
      },
      success: {
        bg: theme.palette.success.main + '1A',
        color: theme.palette.success.main,
      },
      error: {
        bg: theme.palette.error.main + '1A',
        color: theme.palette.error.main,
      },
      warning: {
        bg: theme.palette.warning.main + '1A',
        color: theme.palette.warning.main,
      },
      info: {
        bg: theme.palette.info.main + '1A',
        color: theme.palette.info.main,
      },
    };
    return colorMap[color] || colorMap.primary;
  };

  return (
    <Card
      sx={{
        height: '100%',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
          transform: 'translateY(-4px)',
        },
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body2"
              sx={{
                color: 'text.secondary',
                fontWeight: 500,
                mb: 1,
                fontSize: '0.875rem',
              }}
            >
              {title}
            </Typography>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: 'text.primary',
                mb: 0.5,
              }}
            >
              {value}
            </Typography>
            {subtitle && (
              <Typography
                variant="caption"
                sx={{
                  color: 'text.secondary',
                  display: 'block',
                }}
              >
                {subtitle}
              </Typography>
            )}
            {trend && (
              <Box
                sx={(theme) => ({
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                  mt: 1,
                  color: trend.isPositive ? theme.palette.success.main : theme.palette.error.main,
                })}
              >
                {trend.isPositive ? (
                  <TrendingUp size={16} />
                ) : (
                  <TrendingDown size={16} />
                )}
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 600,
                  }}
                >
                  {trend.value}%
                </Typography>
              </Box>
            )}
          </Box>
          {icon && (
            <Box
              sx={(theme) => {
                const colorStyles = getColorStyles(theme);
                return {
                  width: 48,
                  height: 48,
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: colorStyles.bg,
                  color: colorStyles.color,
                  flexShrink: 0,
                };
              }}
            >
              {icon}
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
